import React from 'react';
import { isEmpty, noop, get, isNil } from 'lodash';
import classnames from 'classnames';

import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import PropTypes from 'prop-types';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { defaultPhoneNumberEnableAutoRefill as DefaultPhoneNumberEnableAutoRefill } from 'ui/views/widgets/defaultPhoneNumberEnableAutoRefill';
 *
 * // render
 * <DefaultPhoneNumberEnableAutoRefill propName='propValue'/>
 */
export const defaultPhoneNumberEnableAutoRefill = ( props ) => {
    const { addAction, title, phoneNumber } = props;

    const isAddActionAllowed = isEmpty( phoneNumber ) || isNil( phoneNumber );

    const _addActionClassName = classnames( 'ui-default-phone-number-enable-auto-refill__add-action' );

    return (
        <div className='ui-default-phone-number-enable-auto-refill'>

            {/* widget title */}
            {! isEmpty( title ) && (
                <div className='ui-default-phone-number-enable-auto-refill__header'>
                    <Icon id={ 'phone' } fill = '#000' width= '22' height= '22'/>
                    <div className='ui-default-phone-number-enable-auto-refill__header__title'>
                        { getLabel( title ) }
                    </div>
                </div>
            ) }

            {
                isAddActionAllowed && (
                    <div className= 'ui-default-phone-number-enable-auto-refill__add-container'>

                        {/* check if add Action is allowed */}
                        { ! isEmpty( addAction ) && (
                            <div className={ _addActionClassName } onClick={ () => { props.onAddPhoneNumber( { ...addAction } ); } }>
                                <Icon id={ 'add' } />
                                <div className='ui-default-phone-number-enable-auto-refill__add-action__title'>{ getLabel( addAction.title ) }</div>
                            </div>
                        ) }
        
                        {/* info card view */}
                        {
                            !isEmpty( props.infoCard ) ? (
                                <div className={ 'ui-default-phone-number-enable-auto-refill__infocard' }>
                                    <div className={ 'ui-default-phone-number-enable-auto-refill__infocard__icon' }>
                                        <Icon name='infoRed' width='14' height='14' fill='#ffffff' />
                                    </div>
                                    <div className={ 'ui-default-phone-number-enable-auto-refill__infocard__description' }>
                                        { getLabel( get( props, 'infoCard.description' ) ) }
                                    </div>
                                </div>
                            ) : null
                        }
                    </div>
                )
            }

            {
                ( !isEmpty( phoneNumber ) && !isNil( phoneNumber ) ) ? (
                    <div className= 'ui-default-phone-number-enable-auto-refill__phone-number'>
                        { phoneNumber }
                    </div>
                ) : null
            }

            
        </div>
    );
};

// set display name
defaultPhoneNumberEnableAutoRefill.displayName = 'defaultPhoneNumberEnableAutoRefill';

// set default props
defaultPhoneNumberEnableAutoRefill.defaultProps = {
    addAction: {},
    title: {}
};

// prop types
defaultPhoneNumberEnableAutoRefill.propTypes = {
    addAction: PropTypes.object,
    title: PropTypes.object,
    phoneNumber: PropTypes.string
};
